import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { endpoints, type MealPlan } from '../api/endpoints';
import { Skeleton } from './states';

// Кол-во блюд → правильное склонение «блюдо/блюда/блюд».
function pluralBlyudo(n: number): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return 'блюдо';
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return 'блюда';
  return 'блюд';
}

// Блок «Меню на неделю» на главном: показывает состояние плана и ведёт в планировщик (/plan).
// Сам план тут НЕ собираем — генерация живёт на /plan (спека §3). Секция не критична:
// при сбое загрузки просто не показываем блок, лента не ломается.
export function MealPlanCard() {
  const nav = useNavigate();
  const [plan, setPlan] = useState<MealPlan | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    endpoints.getMealPlan().then(
      (p) => {
        if (alive) setPlan(p);
      },
      () => {
        if (alive) setFailed(true);
      },
    );
    return () => {
      alive = false;
    };
  }, []);

  if (failed) return null;
  if (!plan) return <Skeleton className="h-24 w-full" />;

  const count = plan.entries.length;

  return (
    <button
      onClick={() => nav('/plan')}
      className="block w-full rounded-2xl bg-gradient-to-br from-primary-50 to-sand/30 p-5 text-left shadow-card ring-1 ring-inset ring-primary-100 transition active:scale-[0.99]"
    >
      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-primary-600/80">Меню на неделю</p>
      {count > 0 ? (
        <>
          <p className="mt-1 text-[17px] font-semibold text-ink">
            Запланировано {count} {pluralBlyudo(count)}
          </p>
          <p className="mt-0.5 text-sm text-primary-700">Открыть меню →</p>
        </>
      ) : (
        <>
          <p className="mt-1 text-[17px] font-semibold text-ink">Соберите меню на неделю</p>
          <p className="mt-0.5 text-sm text-primary-700">✨ Собрать неделю →</p>
        </>
      )}
    </button>
  );
}
